export const EVENTS = {
  ACCOUNT_PLAN: {
    VIEW_ACCOUNT_PLAN: "View Account Plan",
    DOWNLOAD_ACCOUNT_PLAN_CLICKED: "download_account_plan_clicked",
    // Fires when the AI completes account-plan generation (separate from
    // download). Pair this with DOWNLOAD_ACCOUNT_PLAN_CLICKED to track the
    // generate → download funnel.
    ACCOUNT_PLAN_GENERATED: "account_plan_generated",
    // "Fill Out My Account Plan" flow (ENG-2100) — names per the ENG-1715 design doc.
    FILL_UPLOAD_STARTED: "account_plan_upload_started",
    FILL_MODE_SELECTED: "account_plan_upload_mode_selected",
    FILL_GENERATED: "account_plan_upload_generated",
    FILL_ITERATED: "account_plan_upload_iterated",
    FILL_HISTORY_OPENED: "account_plan_history_plan_opened"
  },
  KEY_EXECUTIVE_CHANGES: {
    VIEW_KEY_EXECUTIVE_CHANGES: "View Key executive changes"
  },
  BANNERS: {
    G2_SURVEY_CLICKED: "g2_survey_clicked",
    G2_SURVEY_CLOSED: "g2_survey_closed",
    RENEWAL_BANNER_CLOSED: "renewal_banner_closed"
  },
  HOT_ACCOUNTS: {
    VIEW_STARRED_HOT_ACCOUNTS: "view_starred_hot_accounts"
  },
  COMPONENTS: {
    MODULE_NAV_CLICKED: "module_nav_clicked",
    SUB_HEADER_TAB_CLICKED: "sub_header_tab_clicked",
    ACTIVE_LINK_CLICKED: "active_link_clicked",
    ACTIVE_LINK_PIN_CLICKED: "active_link_pin_clicked",
    ASK_ORBITSHIFT_CLICKED: "ask_orbitshift_clicked",
    ASK_ORBITSHIFT_FAB_DISMISSED: "ask_orbitshift_fab_dismissed",
    PRIORITY_DETAIL_TAB_CLICKED: "priority_detail_tab_clicked",
    THEME_TOGGLED: "theme_toggled",
    PRESENTATION_BUILDER_CLICKED: "presentation_builder_clicked",
    PRE_MEETING_BRIEF_CLICKED: "pre_meeting_brief_clicked",
    CONNECT_EMAIL_PROVIDER_CLICKED: "connect_email_provider_clicked",
    NOT_FOUND_ACTION_CLICKED: "not_found_action_clicked",
    OS_LITE_PAYWALL_CTA_CLICKED: "os_lite_paywall_cta_clicked",
    MOBILE_APP_DOWNLOAD_CLICKED: "mobile_app_download_clicked",
    SEE_MORE_LESS_TOGGLED: "see_more_less_toggled",
    RFP_SELECTOR_CLICKED: "rfp_selector_clicked",
    MARKDOWN_RENDER_CLICKED: "markdown_render_clicked",
    AUDIO_PLAYER_TOGGLED: "audio_player_toggled",
    AUDIO_PLAYER_RATE_CHANGED: "audio_player_rate_changed",
    EXCEL_VIEWER_SHEET_CLICKED: "excel_viewer_sheet_clicked",
    EDITOR_TOOLBAR_CLICKED: "editor_toolbar_clicked",
    EDITOR_TABLE_MENU_CLICKED: "editor_table_menu_clicked",
    EDITOR_IMAGE_CLICKED: "editor_image_clicked",
    IMAGE_PREVIEW_OPENED: "image_preview_opened",
    IMAGE_PREVIEW_CLOSED: "image_preview_closed",
    IMAGE_PREVIEW_NEXT_CLICKED: "image_preview_next_clicked",
    IMAGE_PREVIEW_PREV_CLICKED: "image_preview_prev_clicked"
  },
  EMAIL: {
    SEND_EMAIL_CLICKED: "Send_Email_Clicked",
    EMAIL_MESSAGE_NAVIGATION_BACK_CLICKED:
      "Email_Message_Navigation_Back_Clicked",
    EMAIL_MESSAGE_NAVIGATION_FORWARD_CLICKED:
      "Email_Message_Navigation_Forward_Clicked",
    COPY_MESSAGE_CLICKED: "Copy_Message_Clicked",
    LINKEDIN_MESSAGE_CLICKED: "LinkedIn_Message_Clicked",
    EMAIL_PROMPT_SUBMITTED: "Email_prompt_submitted",
    EMAIL_PROVIDER_MODAL_CLOSED: "email_provider_modal_closed",
    EMAIL_PROVIDER_SELECTED: "email_provider_selected",
    EMAIL_PROVIDER_AUTHORIZE_CLICKED: "email_provider_authorize_clicked",
    EMAIL_COMPOSE_CLOSE_CLICKED: "email_compose_close_clicked",
    EMAIL_PROVIDER_CALENDAR_TOGGLED: "email_provider_calendar_toggled",
    EMAIL_PROVIDER_DISCONNECT_CLICKED: "email_provider_disconnect_clicked"
  },
  PERSONA: {
    FETCH_PERSONA: "fetch_persona"
  },
  COMMON: {
    LINKEDIN_OPENED: "linkedin_opened",
    VIEW_EMAIL_ID: "view_email_id",
    SOURCE_CLICKED: "source_clicked",
    ADD_PERSON_TO_OPP_CLICKED: "add_person_to_opp_clicked",
    ACCOUNT_NOTIFICATIONS_TOGGLED: "account_notifications_toggled"
  }
}

export type BaseEventPropsInput = {
  feature?: string
  accountId?: any
  accountName?: string
  page?: string
}

export const getBaseEventProps = ({
  feature,
  accountId,
  accountName,
  page
}: BaseEventPropsInput = {}) => {
  const baseProps: Record<string, string> = {}
  const resolvedPage =
    page ?? (typeof window !== "undefined" ? window.location.pathname : "")

  if (resolvedPage) {
    baseProps.page = resolvedPage
  }
  if (feature) {
    baseProps.feature = feature
  }
  if (accountId) {
    baseProps.account_id = accountId
  }
  if (accountName) {
    baseProps.account_name = accountName
  }

  return baseProps
}
